<template>
  <div
    class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
    @mouseenter="$sidebar.onMouseEnter()"
    @mouseleave="$sidebar.onMouseLeave()"
    :data="backgroundColor"
  >
    <div class="scrollbar-inner sidebar-inner-flex" ref="sidebarScrollArea">
      <!-- Header com logo -->
      <div class="sidenav-header d-flex align-items-center">
        <b-navbar-brand href="#">
          <img
            src="~@/assets/img/brand/logo_abitue.png"
            class="navbar-brand-img"
            alt="Sidebar logo"
          />
        </b-navbar-brand>
        <div class="ml-auto">
          <div
            class="sidenav-toggler d-none d-xl-block"
            :class="{ active: !$sidebar.isMinimized }"
            @click="minimizeSidebar"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>

      <slot></slot>

      <!-- Links de navegação — ocupa o espaço disponível -->
      <div class="navbar-inner sidebar-nav-grow">
        <b-navbar-nav>
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              />
            </sidebar-item>
          </slot>
        </b-navbar-nav>
      </div>

      <!-- Logout — sempre no fundo -->
      <slot name="links-after"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "sidebar",
    props: {
      title: { type: String, default: "Creative Tim" },
      shortTitle: { type: String, default: "CT" },
      logo: { type: String, default: "~@/assets/img/brand/logo_abitue.png" },
      backgroundColor: {
        type: String,
        default: "vue",
        validator: (value) =>
          ["", "vue", "blue", "green", "orange", "red", "primary"].includes(
            value,
          ),
      },
      sidebarLinks: { type: Array, default: () => [] },
      autoClose: { type: Boolean, default: true },
    },
    provide() {
      return { autoClose: this.autoClose };
    },
    methods: {
      minimizeSidebar() {
        if (this.$sidebar) this.$sidebar.toggleMinimize();
      },
    },
    mounted() {
      this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;
      this.minimizeSidebar();
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) this.$sidebar.showSidebar = false;
    },
  };
</script>

<style scoped>
  /* Faz o scrollbar-inner crescer em altura total e usar flex-column */
  .sidebar-inner-flex {
    display: flex !important;
    flex-direction: column;
    height: 100%;
    min-height: 100vh;
  }

  /* Links de nav crescem e empurram o logout para baixo */
  .sidebar-nav-grow {
    flex: 1;
    padding-top: 0.25rem;
    padding-bottom: 0.5rem;
  }

  /* ── Header ─────────────────────────────────────── */
  .sidenav-header {
    height: 64px;
    padding: 0 1.25rem;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  :deep(.sidenav-header .navbar-brand) {
    padding: 0;
  }

  :deep(.navbar-brand-img) {
    max-height: 28px !important;
  }

  /* ── Toggler ─────────────────────────────────────── */
  .sidenav-toggler {
    padding: 0;
    opacity: 0.35;
    transition: opacity 0.15s ease;
  }
  .sidenav-toggler:hover {
    opacity: 0.8;
  }

  .sidenav-toggler-inner {
    width: 16px;
  }

  .sidenav-toggler-line {
    height: 1.5px;
    width: 16px;
    background-color: #8898aa;
    display: block;
  }
  .sidenav-toggler-line:not(:last-child) {
    margin-bottom: 4px;
  }
</style>
